/* tslint:disable */
/* eslint-disable */
/**
 * crm-phone-agent
 * crm-phone-agent
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ValueWithNote } from './ValueWithNote';
import {
    ValueWithNoteFromJSON,
    ValueWithNoteFromJSONTyped,
    ValueWithNoteToJSON,
} from './ValueWithNote';

/**
 * 
 * @export
 * @interface StructuredAnalysisResponseDataCoverageStatus
 */
export interface StructuredAnalysisResponseDataCoverageStatus {
    /**
     * 
     * @type {ValueWithNote}
     * @memberof StructuredAnalysisResponseDataCoverageStatus
     */
    facility_status?: ValueWithNote;
    /**
     * 
     * @type {ValueWithNote}
     * @memberof StructuredAnalysisResponseDataCoverageStatus
     */
    payer?: ValueWithNote;
    /**
     * 
     * @type {ValueWithNote}
     * @memberof StructuredAnalysisResponseDataCoverageStatus
     */
    plan_type?: ValueWithNote;
    /**
     * 
     * @type {ValueWithNote}
     * @memberof StructuredAnalysisResponseDataCoverageStatus
     */
    benefit_period?: ValueWithNote;
    /**
     * 
     * @type {ValueWithNote}
     * @memberof StructuredAnalysisResponseDataCoverageStatus
     */
    previous_stay_in_current_benefit_period?: ValueWithNote;
    /**
     * 
     * @type {ValueWithNote}
     * @memberof StructuredAnalysisResponseDataCoverageStatus
     */
    most_recent_snf_stay?: ValueWithNote;
    /**
     * 
     * @type {ValueWithNote}
     * @memberof StructuredAnalysisResponseDataCoverageStatus
     */
    npi_of_previous_stay_facility?: ValueWithNote;
}

/**
 * Check if a given object implements the StructuredAnalysisResponseDataCoverageStatus interface.
 */
export function instanceOfStructuredAnalysisResponseDataCoverageStatus(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function StructuredAnalysisResponseDataCoverageStatusFromJSON(json: any): StructuredAnalysisResponseDataCoverageStatus {
    return StructuredAnalysisResponseDataCoverageStatusFromJSONTyped(json, false);
}

export function StructuredAnalysisResponseDataCoverageStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): StructuredAnalysisResponseDataCoverageStatus {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'facility_status': !exists(json, 'facility_status') ? undefined : ValueWithNoteFromJSON(json['facility_status']),
        'payer': !exists(json, 'payer') ? undefined : ValueWithNoteFromJSON(json['payer']),
        'plan_type': !exists(json, 'plan_type') ? undefined : ValueWithNoteFromJSON(json['plan_type']),
        'benefit_period': !exists(json, 'benefit_period') ? undefined : ValueWithNoteFromJSON(json['benefit_period']),
        'previous_stay_in_current_benefit_period': !exists(json, 'previous_stay_in_current_benefit_period') ? undefined : ValueWithNoteFromJSON(json['previous_stay_in_current_benefit_period']),
        'most_recent_snf_stay': !exists(json, 'most_recent_snf_stay') ? undefined : ValueWithNoteFromJSON(json['most_recent_snf_stay']),
        'npi_of_previous_stay_facility': !exists(json, 'npi_of_previous_stay_facility') ? undefined : ValueWithNoteFromJSON(json['npi_of_previous_stay_facility']),
    };
}

export function StructuredAnalysisResponseDataCoverageStatusToJSON(value?: StructuredAnalysisResponseDataCoverageStatus | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'facility_status': ValueWithNoteToJSON(value.facility_status),
        'payer': ValueWithNoteToJSON(value.payer),
        'plan_type': ValueWithNoteToJSON(value.plan_type),
        'benefit_period': ValueWithNoteToJSON(value.benefit_period),
        'previous_stay_in_current_benefit_period': ValueWithNoteToJSON(value.previous_stay_in_current_benefit_period),
        'most_recent_snf_stay': ValueWithNoteToJSON(value.most_recent_snf_stay),
        'npi_of_previous_stay_facility': ValueWithNoteToJSON(value.npi_of_previous_stay_facility),
    };
}

